import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";

import { useModelPopup } from "../../../../../../common/hooks";
import styles from "../projectDetails.module.scss";
import { makeProjectField } from "../../../../../../common/helper";
import ProjectFieldsEdit from "modules/projects/project/overview/projectDetails/projectFieldsEdit.component";
import { Icon, smSize } from "../../../../../../common/icon";
import ProjectDetailsGroup from "modules/projects/project/overview/projectDetails/projectDetailsGroup";
import ProjectDetailsWithoutGroup from "modules/projects/project/overview/projectDetails/projectDetailsWithoutGroup";

const ProjectDetailsGroups = ({
 canManageTasks,
 metrics,
 setEditMetrics,
 isAdmin,
}) => {
  const popup = useModelPopup();

  const selectedCouncil = useSelector((state) => state.councilReducer.selectedCouncil);
  const selectedProject = useSelector((state) => state.projectsReducer.projectReducer.selectedProject);
  const fieldGroups = useSelector((state) => state.projectsReducer.projectReducer.fieldGroups);

  const [expandAll, setExpandAll] = useState(false);

  const isFordSupplyChainAutomation = useMemo(() => {
    return (
      selectedCouncil?.name === "Ford" &&
      selectedProject?.stage_template?.name === "Supply Chain Automation"
    );
  }, [selectedCouncil?.name, selectedProject?.stage_template?.name]);

  const handleGroupEdit = (group) => {
    if (group?.name === "Implementation" && selectedCouncil?.name === "Ford") {
      setEditMetrics();
      return;
    }
    const newGroup = {
      ...group,
      project_fields: group.project_fields.map(makeProjectField),
    };

    popup.show({
      title: `Edit ${newGroup.name || ""} group`,
      component: <ProjectFieldsEdit selectedGroup={newGroup} />,
    });
  };

  return (
    <div className={styles.body}>
      <div className="d-flex flex-row align-items-center flex-wrap w-100">
        <div className="d-flex justify-content-end w-100">
          <span
            className={styles.buttonLink}
            onClick={() => setExpandAll((prev) => !prev)}
          >
            {expandAll ? "Collapse" : "Expand"} All
          </span>
        </div>
        <div className="d-flex flex-column w-100 position-relative">
          {fieldGroups?.project_fields_with_groups?.length > 0 ? (
            <div className="d-flex flex-column mt-3">
              {fieldGroups?.project_fields_with_groups.filter(group => {
                return !(isFordSupplyChainAutomation && group.name === "Project Overview");
              })
                .map((group) => (
                  <ProjectDetailsGroup
                    key={group.id}
                    canManageTasks={canManageTasks}
                    metrics={metrics}
                    setEditMetrics={setEditMetrics}
                    isAdmin={isAdmin}
                    group={group}
                    expandAll={expandAll}
                  />
                ))}
            </div>
          ) : null}
          <hr className="mt-3 mb-5" />
          {fieldGroups?.project_fields_without_groups?.length > 0 ? (
            <div className="d-flex flex-row flex-wrap position-relative">
              {canManageTasks && (
                <div
                  className="cursor-pointer position-absolute"
                  style={{ right: 0 }}
                  onClick={() =>
                    handleGroupEdit({
                      name: null,
                      id: null,
                      project_fields:
                      fieldGroups?.project_fields_without_groups,
                    })
                  }
                >
                  <Icon {...smSize} icon="icn-edit" />
                </div>
              )}
              {fieldGroups?.project_fields_without_groups
                .filter(
                  (f) =>
                    f.field_name !== "Possible Replications (Plants)" &&
                    f.field_name !== "Possible Replications (Areas)"
                )
                .map((field) => <ProjectDetailsWithoutGroup field={field} key={field.id} />)}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default React.memo(ProjectDetailsGroups);
